import type { JSX } from 'react'

import { isGradient } from 'utils/helpers'
import { COLOR } from 'vars/index'
import {
  ProgressLineGradientColorSC,
  ProgressLineSimpleColorSC,
} from './ProgressLine.styled'

export interface IProgressLine {
  backgroundOverlay?: COLOR
  borderColor?: COLOR
  position?: number
}

export const ProgressLine = ({
  backgroundOverlay = COLOR.PROGRESS_LINE_OVERLAY,
  borderColor = COLOR.ACCENT_TERTIARY,
  position,
}: IProgressLine): JSX.Element => {
  const isGradientColor = isGradient(borderColor)

  const ProgressLineSC = isGradientColor
    ? ProgressLineGradientColorSC
    : ProgressLineSimpleColorSC

  return (
    <ProgressLineSC
      backgroundOverlay={backgroundOverlay}
      borderColor={borderColor}
      position={position}
    />
  )
}
